<template>
  <div class="page">
    <div class="d-flex">
      <search-bar
        style="flex: 1 0 auto"
        @search="handleSearch"
        @typing="onChangeInputSearch"
        :searchTerm="query"
      />
      <div class="d-flex align-items-center ml-10">
        <action-button
          :class="'d-inline-block mr-5 mt-0 w-auto'"
          :label="'Add Member'"
          :theme="{ primary, secondary, event, danger }"
          @customEvent="onClickAddMember"
        />

        <!-- TODO: For production -->
        <!-- <action-button
          label="Bulk Upload"
          :theme="{ primary, secondary, event, danger }"
          class="mt-0 d-inline-block w-auto"
          @customEvent="handleBulkUpload"
        /> -->
      </div>
    </div>
    <div class="content--main">
      <div v-if="loaders.typing">Searching...</div>
      <spinner :theme="primary" v-else-if="loaders.network" />
      <div v-else-if="$store.state.admin.users.length === 0">
        No results found.
      </div>
      <div v-else class="row">
        <div class="col-4 page--list-wrapper">
          <div v-scroll="onWidgetScroll" class="page--list">
            <template v-if="$store.state.admin.users.length > 0">
              <widget
                v-for="user of users"
                :key="user.id"
                :details="generateDetails(user)"
                :style="{
                  backgroundColor: isActive(user.id) ? secondary : '#fafafa',
                  transition: 'background-color 0.2s ease'
                }"
                :id="user.id"
                :widgets="user"
                @mouseover.native="active = user.id"
                @mouseleave.native="active = -1"
                @widgetClick="onClickWidget(user)"
              >
              </widget>
              <div v-if="loaders.users" class="widget-loader">
                <div class="loader">
                  <spinner :theme="primary" class="loader-spinner" />
                </div>
              </div>
              <!-- End of Widget -->
            </template>
          </div>
        </div>
        <!-- End of Col 4 -->

        <div class="col-8 page--profile-wrapper">
          <div class="page--profile">
            <div v-if="loaders.profile" class="loader">
              <spinner class="loader-spinner" :theme="primary" />
            </div>
            <widget-details
              v-if="activeUser"
              :title="'Profile'"
              :widgetOptions="widgetOptions"
              @changePassword="handleMemberChangePass"
              @deleteMember="handleMemberDelete"
              @updateMember="handleMemberUpdate"
            >
              <member-profile
                :categories="categories"
                @ordersLength="handleOrdersLength"
                @loading="handleProfileLoading"
              />
            </widget-details>
          </div>
        </div>
      </div>
      <!-- End of Row -->
    </div>
  </div>
</template>

<script>
import { ActionButton, SearchBar, Widget, WidgetDetails } from "@/components";
import Spinner from "@/components/Spinner";
import { socketSender } from "@/helpers/socket";
import MemberProfile from "./MemberProfile";
import searchInput from "./_parseSearch";
import widgetOptions from "./_widgetOptions";

const name = "admin-users";
const components = {
  ActionButton,
  SearchBar,
  Spinner,
  MemberProfile,
  Widget,
  WidgetDetails
};
const data = () => ({
  action: "",
  active: -1,
  categories: [],
  length: 0,
  loaders: {
    typing: false,
    network: true,
    profile: false,
    users: false
  },
  query: "",
  widgetOptions
});

const methods = {
  async init(query = "") {
    await this.$store.dispatch("USER_LIST_RESET");
    await this.$store.dispatch("USER_LIST_PAGINATE", query);
    this.loaders.network = false;
    this.paginated("categories");
    this.action = query;
  },
  // Methods
  generateDetails(user) {
    return {
      image: user.avatar,
      title: user.firstName + " " + user.lastName,
      subtitle: user.Roles.length > 0 ? user.Roles[0].name : ""
    };
  },
  generateWidgetOption() {
    return widgetOptions;
  },
  isActive(id) {
    if (id) {
      if (this.active == id) return true;
      if (this.activeUser) {
        return this.activeUser.id == id;
      }
    }
    return false;
  },
  paginated(collection, action = "", page = 1) {
    this.$http
      .get(`/${collection}?page[number]=${page}&page[size]=10&${action}`)
      .then(response => {
        var { data, meta } = response.data;
        data = data.map(product => ({
          label: product.name,
          value: product.id
        }));
        this[collection] = [...this[collection], ...data];
        if (meta.hasNextPage) {
          this.paginated(collection, action, page + 1);
        }
      });
  },

  // Handle Event Listener
  handleOrdersLength(length) {
    this.length = length;
  },
  handleBulkUpload() {
    const name = "bulk-upload-member";
    const modal = "admin-members-bulk-uploa-memberd";
    this.$emit("showModal", { modal, name });
  },
  async handleSearch(word) {
    this.action = searchInput(word);
    this.loaders.network = true;
    await this.$store.dispatch("USER_LIST_PAGINATE", this.action);
    this.loaders.network = false;
  },
  handleMemberUpdate() {
    const modal = "admin-members-page-add-member";
    const name = "edit-member";
    const singleRecord = this.activeUser;
    this.$emit("showModal", {
      modal,
      name,
      singleRecord,
      hasBackdropEvent: false
    });
  },
  handleMemberDelete() {
    if (this.length > 0) {
      this.$swal({
        html: "<b>Member has bookings. Can't deactivate member.</b>",
        type: "error"
      });
    } else {
      this.$swal({
        html: "<b>Do you want to deactivate this member?</b>",
        type: "warning",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        showCancelButton: true
      }).then(async result => {
        if (result.value == true) {
          socketSender(
            "updateLog",
            `${this.$store.getters.getFullUser} deactivated the user ${this.activeUser.firstName} ${this.activeUser.lastName}`
          );
          this.$store.dispatch("USER_DELETE", this.activeUser.id);
        }
      });
    }
  },
  handleMemberChangePass() {
    const modal = "admin-members-page-add-member";
    const name = "change-password";
    const singleRecord = this.activeUser;
    this.$emit("showModal", {
      modal,
      name,
      singleRecord,
      hasBackdropEvent: false
    });
  },
  handleProfileLoading(isLoading) {
    this.loaders.profile = isLoading;
  },

  // Event Trigger
  onChangeInputSearch(isTyping) {
    this.$store.dispatch("USER_LIST_RESET");
    this.loaders.typing = isTyping;
  },
  onClickAddMember() {
    this.$emit("showModal", {
      modal: "admin-members-page-add-member",
      name: "add-member",
      hasBackdropEvent: false
    });
  },
  onClickWidget(user) {
    this.$store.dispatch("USER_REMOVE_NEW_TAG", user.id);
    this.$store.dispatch("SET_ACTIVE_USER", user);
    this.length = 0;
  },
  async onWidgetScroll(el, position) {
    const divScrollHeight = Math.floor(el.target.scrollHeight);
    const scrollCurrentHeight = Math.floor(
      position.scrollTop + el.target.offsetHeight
    );
    if (
      divScrollHeight === scrollCurrentHeight ||
      (this.users.length === 40 && this.loaders.users === false)
    ) {
      this.loaders.users = true;
      await this.$store.dispatch("USER_LIST_PAGINATE", this.action);
      this.loaders.users = false;
    }
  },
  scrollToActive() {
    var userHistory = this.historyPickedUser;
    if (userHistory) {
      document
        .getElementById(`${userHistory.id}`)
        .scrollIntoView({ block: "start" });
    }
  }
};

function created() {
  this.query = this.historyPickedUser ? this.historyPickedUser.email : "";
  this.init(searchInput(this.query));
}

const computed = {
  primary() {
    return this.$store.state.app.scheme.primary;
  },
  secondary() {
    return this.$store.state.app.scheme.secondary;
  },
  event() {
    return this.$store.state.app.scheme.event;
  },
  danger() {
    return this.$store.state.app.scheme.danger;
  },
  activeUser() {
    return this.$store.state.admin.activeUser;
  },
  historyPickedUser() {
    return this.$store.state.admin.historyPickedUser;
  },
  users() {
    return this.$store.state.admin.users;
  }
};

export default {
  data,
  created,
  components,
  computed,
  methods,
  name
};
</script>

<style lang="scss" scoped>
@import "./__users.scss";
</style>
